import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Table, Modal, Spin, Card, message, Switch } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { adminAPI } from '../api/admin';

export default function SMSTemplateManager() {
  const [form] = Form.useForm();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadTemplates();
  }, []);

  const loadTemplates = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getSMSTemplates();
      if (response.data.success) {
        setTemplates(response.data.templates);
      }
    } catch (error) {
      message.error('خطا در بارگذاری الگوها');
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      let response;
      if (editingId) {
        response = await adminAPI.updateSMSTemplate(editingId, values);
      } else {
        response = await adminAPI.createSMSTemplate(values);
      }

      if (response.data.success) {
        message.success('الگو با موفقیت ذخیره شد!');
        form.resetFields();
        setEditingId(null);
        setIsModalVisible(false);
        loadTemplates();
      }
    } catch (error) {
      message.error(error.response?.data?.message || 'خطا در ذخیره');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    form.setFieldsValue(record);
    setEditingId(record._id);
    setIsModalVisible(true);
  };

  const columns = [
    {
      title: 'نام',
      dataIndex: 'name'
    },
    {
      title: 'توضیح',
      dataIndex: 'description'
    },
    {
      title: 'الگو',
      dataIndex: 'template',
      ellipsis: true,
      render: (text) => <code>{text}</code>
    },
    {
      title: 'فعال',
      render: (_, record) => record.isActive ? '✅' : '❌'
    },
    {
      title: 'عمل',
      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEdit(record)}
        >
          ویرایش
        </Button>
      )
    }
  ];

  return (
    <Card title="مدیریت الگوهای SMS">
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => {
          form.resetFields();
          setEditingId(null);
          setIsModalVisible(true);
        }}
        style={{ marginBottom: '16px' }}
      >
        الگوی جدید
      </Button>

      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={templates}
          rowKey="_id"
          pagination={false}
        />
      </Spin>

      <Modal
        title={editingId ? 'ویرایش الگو' : 'الگوی جدید'}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="name"
            label="نام"
            rules={[{ required: true }]}
          >
            <Input placeholder="invitation, welcome, ..." />
          </Form.Item>

          <Form.Item
            name="description"
            label="توضیح"
          >
            <Input.TextArea rows={2} />
          </Form.Item>

          <Form.Item
            name="template"
            label="متن الگو"
            rules={[{ required: true }]}
          >
            <Input.TextArea
              rows={5}
              placeholder="استفاده از متغیرها: {firstName}, {link}, {code}, ..."
            />
          </Form.Item>

          <Form.Item
            name="isActive"
            label="فعال"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Button type="primary" htmlType="submit" block loading={loading}>
            ذخیره
          </Button>
        </Form>
      </Modal>
    </Card>
  );
}
